import { IconComponentProps } from '../IconTypes';

const ChevronDownNoArea = ({ className }: IconComponentProps) => (
  <svg className={className} fill="none" height="6" viewBox="0 0 10 6" width="10" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.00012 4.30482L8.93372 0.371226C9.17591 0.125133 9.57278 0.127163 9.81692 0.370913C10.0611 0.614663 10.0611 1.01037 9.81692 1.25451L5.44192 5.62951C5.31997 5.75162 5.16028 5.81263 5.00012 5.81263C4.83997 5.81263 4.67981 5.75013 4.55794 5.62982L0.182936 1.25482C-0.0612045 1.01107 -0.0608139 0.615367 0.182936 0.371226C0.426686 0.127086 0.822389 0.127086 1.06653 0.371226L5.00012 4.30482Z"
      fill="#113183"
    />
  </svg>
);

export default ChevronDownNoArea;
